export default __webpack_public_path__ + "static/media/partenariat.b04abd71.svg";